import { Component } from '@angular/core';

import { BtnActionComponent } from '../btn-action/btn-action.component';

@Component({
    selector: 'aa-btn-action-primary',
    templateUrl: '../btn-action/btn-action.component.html',
    styleUrls: [
        '../btn-action/btn-action.component.scss',
        './btn-action-primary.component.scss'
    ],
    standalone: false
})
export class BtnActionPrimaryComponent extends BtnActionComponent
{
    constructor ()
    {
        super();
    }
}
